import { rcpaPricingVersions, rcphPricingVersions } from '@orus.eu/pricing'
import {
  esMrpwPricingVersionsDefinitions,
  esMrpaxePricingVersions,
  esRcphPricingVersions,
  frAupaPricingVersions,
  frMrgaPricingVersions,
  frMrpaxePricingVersions,
  frPrelPricingVersions,
  frRcpaxePricingVersions,
  frRccwPricingVersions,
  frRcpwPricingVersions,
  mrpaPricingVersions,
  nlAovqlPricingVersions,
  nlRcphPricingVersions,
  mrpwPricingVersions,
  type Product,
  rcdaPricingVersions,
  rcpaxaPricingVersions,
} from '@orus.eu/product'

import type { AbstractDimension, TypeOfDimension } from './abstract-dimension.ts'
import { StringsWithDataEnumDimension } from './strings-with-data-enum-dimension.ts'

export const mutaPricingVersionDimension = new StringsWithDataEnumDimension({
  name: 'mutaPricingVersion',
  displayKeys: { name: 'dimension_name_muta_pricing_version' },
  entries: [
    ['muta-1.0-2024-11-19', { label: 'Version 1' }],
    ['muta-1.1-2025-03-05', { label: 'Version 1.1 - New business 2025' }],
    ['muta-1.2-2025-03-05', { label: 'Version 1.2 - Renewal 2025' }],
    ['muta-1.3-2026-02-26', { label: 'Version 1.3 - New business 2026' }],
    ['muta-1.4-2026-04-10', { label: 'Version 1.4 - Renewal 2026' }],
  ],
  newerReleaseMayAddValues: true,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type MutaPricingVersion = TypeOfDimension<typeof mutaPricingVersionDimension>

export const rcdaPricingVersionDimension = new StringsWithDataEnumDimension({
  name: 'rcdaPricingVersion',
  displayKeys: { name: 'dimension_name_rcda_pricing_version' },
  entries: rcdaPricingVersions,
  newerReleaseMayAddValues: true,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type RcdaPricingVersion = TypeOfDimension<typeof rcdaPricingVersionDimension>

export const mrphPricingVersionDimension = new StringsWithDataEnumDimension({
  name: 'mrphPricingVersion',
  displayKeys: { name: 'dimension_name_mrph_pricing_version' },
  entries: [
    ['mrph-1.0-2024-11-19', { label: 'Version 1' }],
    ['mrph-1.1-2024-11-22', { label: 'Version 1.1 - MaJ CatNat' }],
    ['mrph-1.2-2025-07-01', { label: 'Version 1.2 - Update fire tax' }],
    ['mrph-1.3-2027-01-01', { label: 'Version 1.3 - Terrorism tax €8.50' }],
  ],
  newerReleaseMayAddValues: true,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type MrphPricingVersion = TypeOfDimension<typeof mrphPricingVersionDimension>

export const rcphPricingVersionDimension = new StringsWithDataEnumDimension({
  name: 'rcphPricingVersion',
  displayKeys: { name: 'dimension_name_rcph_pricing_version' },
  entries: rcphPricingVersions,
  newerReleaseMayAddValues: true,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type RcphPricingVersion = TypeOfDimension<typeof rcphPricingVersionDimension>

export const mrpwPricingVersionDimension = new StringsWithDataEnumDimension({
  name: 'mrpwPricingVersion',
  displayKeys: { name: 'dimension_name_mrpw_pricing_version' },
  entries: mrpwPricingVersions,
  newerReleaseMayAddValues: true,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type MrpwPricingVersion = TypeOfDimension<typeof mrpwPricingVersionDimension>

export const esRcphPricingVersionDimension = new StringsWithDataEnumDimension({
  name: 'esRcphPricingVersion',
  displayKeys: { name: 'dimension_name_es_rcph_pricing_version' },
  entries: esRcphPricingVersions,
  newerReleaseMayAddValues: true,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type EsRcphPricingVersion = TypeOfDimension<typeof esRcphPricingVersionDimension>

export const rcpaPricingVersionDimension = new StringsWithDataEnumDimension({
  name: 'rcpaPricingVersion',
  displayKeys: { name: 'dimension_name_rcpa_pricing_version' },
  entries: rcpaPricingVersions,
  newerReleaseMayAddValues: true,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type RcpaPricingVersion = TypeOfDimension<typeof rcpaPricingVersionDimension>

export const rcpaxaPricingVersionDimension = new StringsWithDataEnumDimension({
  name: 'rcpaxaPricingVersion',
  displayKeys: { name: 'dimension_name_rcpaxa_pricing_version' },
  entries: rcpaxaPricingVersions,
  newerReleaseMayAddValues: true,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
type RcpaxaPricingVersion = TypeOfDimension<typeof rcpaxaPricingVersionDimension>

export const mrpaPricingVersionDimension = new StringsWithDataEnumDimension({
  name: 'mrpaPricingVersion',
  displayKeys: { name: 'dimension_name_mrpa_pricing_version' },
  entries: mrpaPricingVersions,
  newerReleaseMayAddValues: true,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type MrpaPricingVersion = TypeOfDimension<typeof mrpaPricingVersionDimension>

export const frPrelPricingVersionDimension = new StringsWithDataEnumDimension({
  name: 'frPrelPricingVersion',
  displayKeys: { name: 'dimension_name_mrpa_pricing_version' },
  entries: frPrelPricingVersions,
  newerReleaseMayAddValues: true,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type FrPrelPricingVersion = TypeOfDimension<typeof frPrelPricingVersionDimension>

export const nlRcphPricingVersionDimension = new StringsWithDataEnumDimension({
  name: 'nlRcphPricingVersion',
  displayKeys: { name: 'dimension_name_nl_rcph_pricing_version' },
  entries: nlRcphPricingVersions,
  newerReleaseMayAddValues: true,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type NlRcphPricingVersion = TypeOfDimension<typeof nlRcphPricingVersionDimension>

export const frRcpwPricingVersionDimension = new StringsWithDataEnumDimension({
  name: 'frRcpwPricingVersion',
  displayKeys: { name: 'dimension_name_fr_rcpw_pricing_version' },
  entries: frRcpwPricingVersions,
  newerReleaseMayAddValues: true,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type FrRcpwPricingVersion = TypeOfDimension<typeof frRcpwPricingVersionDimension>

export const esMrpwPricingVersionDimension = new StringsWithDataEnumDimension({
  name: 'esMrpwPricingVersion',
  displayKeys: { name: 'dimension_name_es_mrpw_pricing_version' },
  entries: esMrpwPricingVersionsDefinitions,
  newerReleaseMayAddValues: true,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type EsMrpwPricingVersion = TypeOfDimension<typeof esMrpwPricingVersionDimension>

export const frRccwPricingVersionDimension = new StringsWithDataEnumDimension({
  name: 'frRccwPricingVersion',
  displayKeys: { name: 'dimension_name_fr_rccw_pricing_version' },
  entries: frRccwPricingVersions,
  newerReleaseMayAddValues: true,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type FrRccwPricingVersion = TypeOfDimension<typeof frRccwPricingVersionDimension>

export const nlAovqlPricingVersionDimension = new StringsWithDataEnumDimension({
  name: 'nlAovqlPricingVersion',
  displayKeys: { name: 'dimension_name_nl_aovql_pricing_version' },
  entries: nlAovqlPricingVersions,
  newerReleaseMayAddValues: true,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type NlAovqlPricingVersion = TypeOfDimension<typeof nlAovqlPricingVersionDimension>

export const frAupaPricingVersionDimension = new StringsWithDataEnumDimension({
  name: 'frAupaPricingVersion',
  displayKeys: { name: 'dimension_name_fr_aupa_pricing_version' },
  entries: frAupaPricingVersions,
  newerReleaseMayAddValues: true,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type FrAupaPricingVersion = TypeOfDimension<typeof frAupaPricingVersionDimension>

export const frMrgaPricingVersionDimension = new StringsWithDataEnumDimension({
  name: 'frMrgaPricingVersion',
  displayKeys: { name: 'dimension_name_fr_mrga_pricing_version' },
  entries: frMrgaPricingVersions,
  newerReleaseMayAddValues: true,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type FrMrgaPricingVersion = TypeOfDimension<typeof frMrgaPricingVersionDimension>

export const frMrpaxePricingVersionDimension = new StringsWithDataEnumDimension({
  name: 'frMrpaxePricingVersion',
  displayKeys: { name: 'dimension_name_fr_mrpaxe_pricing_version' },
  entries: frMrpaxePricingVersions,
  newerReleaseMayAddValues: true,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type FrMrpaxePricingVersion = TypeOfDimension<typeof frMrpaxePricingVersionDimension>

export const frRcpaxePricingVersionDimension = new StringsWithDataEnumDimension({
  name: 'frRcpaxePricingVersion',
  displayKeys: { name: 'dimension_name_fr_rcpaxe_pricing_version' },
  entries: frRcpaxePricingVersions,
  newerReleaseMayAddValues: true,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type FrRcpaxePricingVersion = TypeOfDimension<typeof frRcpaxePricingVersionDimension>

export const esMrpaxePricingVersionDimension = new StringsWithDataEnumDimension({
  name: 'esMrpaxePricingVersion',
  displayKeys: { name: 'dimension_name_es_mrpaxe_pricing_version' },
  entries: esMrpaxePricingVersions,
  newerReleaseMayAddValues: true,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type EsMrpaxePricingVersion = TypeOfDimension<typeof esMrpaxePricingVersionDimension>

export type PricingVersion =
  | EsMrpaxePricingVersion
  | FrMrpaxePricingVersion
  | FrRcpaxePricingVersion
  | FrMrgaPricingVersion
  | FrAupaPricingVersion
  | NlAovqlPricingVersion
  | FrRccwPricingVersion
  | MutaPricingVersion
  | RcdaPricingVersion
  | MrphPricingVersion
  | RcphPricingVersion
  | MrpwPricingVersion
  | EsRcphPricingVersion
  | RcpaPricingVersion
  | MrpaPricingVersion
  | FrPrelPricingVersion
  | FrRcpwPricingVersion
  | NlRcphPricingVersion
  | RcpaxaPricingVersion
  | EsMrpwPricingVersion

export const pricingVersionDimensionsByProduct = {
  muta: mutaPricingVersionDimension,
  rcda: rcdaPricingVersionDimension,
  mrph: mrphPricingVersionDimension,
  rcph: rcphPricingVersionDimension,
  mrpw: mrpwPricingVersionDimension,
  'es-rcph': esRcphPricingVersionDimension,
  rcpa: rcpaPricingVersionDimension,
  mrpa: mrpaPricingVersionDimension,
  'fr-prel': frPrelPricingVersionDimension,
  'nl-rcph': nlRcphPricingVersionDimension,
  'fr-rcpw': frRcpwPricingVersionDimension,
  rcpaxa: rcpaxaPricingVersionDimension,
  'es-mrpw': esMrpwPricingVersionDimension,
  'fr-rccw': frRccwPricingVersionDimension,
  'nl-aovql': nlAovqlPricingVersionDimension,
  'fr-aupa': frAupaPricingVersionDimension,
  'fr-mrga': frMrgaPricingVersionDimension,
  'fr-mrpaxe': frMrpaxePricingVersionDimension,
  'fr-rcpaxe': frRcpaxePricingVersionDimension,
  'es-mrpaxe': esMrpaxePricingVersionDimension,
} as const satisfies Record<Product, AbstractDimension>

export type PricingVersionByProduct = {
  [key in Product]: TypeOfDimension<(typeof pricingVersionDimensionsByProduct)[key]> | null | undefined
}
